const locationsList = document.querySelector('.locations-list');
const loadMoreButton = document.querySelector('.locations-list__load-more');
const locationLimit = 10;

const fetchLocations = (coordinates, offset = 0) => {
    return fetch(
        '/actions/location-api/location/wells-for-coordinates?' +
            new URLSearchParams({
                lat: coordinates.latitude,
                lng: coordinates.longitude,
                limit: locationLimit,
                offset: offset,
            }),
        {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        },
    ).then(response => response.json());
};

const locationTemplate = location => {
    let locationDistance = location.distance;
    let locationDistanceString = locationsList.dataset.distanceString;
    let locationDistanceUnit = 'km';
    let locationDistanceUnitString = locationsList.dataset.unitKilometerString;
    let locationImage = `<img class="location-entry__picture-placeholder" aria-hidden="true" alt="" src="/dist/images/well-marker.svg"></img>`;
    const locationAddress = [location.location.street1, location.location.city]
        .filter(Boolean)
        .join(', ');

    if (location.distance < 1) {
        locationDistance = locationDistance * 1000;
        locationDistanceUnitString = locationsList.dataset.unitMeterString;
        locationDistanceUnit = 'm';
    }

    if (location.image !== null) {
        locationImage = `
            <img class="location-entry__picture"
                alt="${location.image.alt}"
                srcset="${location.image.srcset}"
                sizes="(min-width: 768px) 200px, 120px"
                src="${location.image.src}">`;
    }

    locationDistance = locationDistance.toLocaleString('de-DE', { maximumSignificantDigits: 3 });
    locationDistanceString = locationDistanceString.replace(
        '{distance}',
        locationDistance + ' ' + locationDistanceUnitString,
    );
    locationDistance = locationDistance + '&nbsp;' + locationDistanceUnit;

    return `
        <li class="location-entry__item">
            <article class="location-entry">
                ${locationImage}

                <div class="location-entry__details">
                    <h2 class="location-entry__name">
                        <a class="location-entry__link" href="${location.url}">${location.title}</a>
                    </h2>
                    <p class="location-entry__address">${locationAddress}</p>

                    <p class="location-entry__distance">
                        <span class="visually-hidden">${locationDistanceString}</span>
                        <span aria-hidden="true">${locationDistance}</span>
                    </p>
                </div>

                <div class="location-entry__icon-wrapper" aria-hidden="true">
                    <svg class="location-entry__icon" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 320 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M96 480c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L242.8 256L73.38 86.63c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l192 192c12.5 12.5 12.5 32.75 0 45.25l-192 192C112.4 476.9 104.2 480 96 480z"/></svg>
                </div>
            </article>
        </li>`;
};

const renderLocationsList = data => {
    const locations = data.result;
    const locationHtml = locations.map(locationTemplate).join('');
    locationsList.hidden = false;
    locationsList.insertAdjacentHTML('beforeend', locationHtml);

    loadMoreButton.hidden = locations.length < locationLimit;
};

const fetchAndRenderLocations = () => {
    const offset = loadMoreButton.dataset.offset || 0;
    const coordinates = JSON.parse(loadMoreButton.dataset.coordinates);

    fetchLocations(coordinates, offset)
        .then(data => {
            renderLocationsList(data);
            const newOffset = Number(offset) + data.result.length;
            loadMoreButton.dataset.offset = newOffset;
            loadMoreButton.hidden = newOffset >= data.total;
        })
        .catch(error => {
            console.error(error);
            alert(
                'Die Liste der Brunnen kann momentan nicht geladen werden. Bitte versuchen Sie es später erneut.',
            );
        });
};

const updateLocationDisplay = coordinates => {
    locationsList.innerHTML = '';
    locationsList.hidden = true;
    loadMoreButton.dataset.offset = 0;
    loadMoreButton.dataset.coordinates = JSON.stringify(coordinates);
    fetchAndRenderLocations();
};

loadMoreButton.addEventListener('click', fetchAndRenderLocations);

window.registerGeolocationCallback(coordinates => updateLocationDisplay(coordinates));
window.requestUpdateByGeolocation();
